import "src/pages/home/components/RoomCard/RoomCardXS/sections/shared/Wrapper/Wrapper.css"
import "src/pages/home/components/RoomCard/RoomCardXS/RoomCardXS.css"
import SkeletonItem from "./SkeletonItem"

function SkeletonCardMD() {
    return (
        <div className="room-card--xs__container">
            <div className="room-card--xs__wrapper" style={{ backgroundColor: "var(--white)" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <SkeletonItem width={28} height={28} borderRadius="50%" />
                    <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-end", flex: 1, marginLeft: 8 }}>
                        <SkeletonItem width="50%" height={14} borderRadius={6} />
                        <SkeletonItem width="25%" height={14} borderRadius={6} />
                    </div>
                </div>
                <SkeletonItem width="100%" height={14} borderRadius={6} />
                <SkeletonItem width="80%" height={14} borderRadius={6} style={{ alignSelf: "center" }} />
            </div>
        </div>
    )
}

export default SkeletonCardMD
